import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form'
import { Button } from 'components/Button/Button'
import { MyDropdown } from 'components/ReactHookForm/MyDropdown'
import { MspSortDirection, MspSortForm, MspSortType } from 'models/claims'
import classNames from 'classnames'

export interface MspCaseSortProps {
  classType: string
  sortDirection: MspSortDirection
  sortType: MspSortType
  onSubmit: SubmitHandler<MspSortForm>
  className?: string
}

export const MspCaseSort: FC<MspCaseSortProps> = ({ classType, sortDirection, sortType, onSubmit, className }) => {
  const { t } = useTranslation(classType, { keyPrefix: 'sort' })

  const formMethods = useForm<MspSortForm>({
    defaultValues: { sortType, sortDirection }
  })

  const sortByOpts = [
    { label: t('incidentDate'), value: MspSortType.INCIDENT_DATE },
    { label: t('caseType'), value: MspSortType.CASE_TYPE },
    { label: t('caseId'), value: MspSortType.CASE_ID }
  ]

  const sortDirectionOpts = [
    { label: t('ascending'), value: MspSortDirection.ASC },
    { label: t('descending'), value: MspSortDirection.DESC }
  ]

  return (
    <FormProvider {...formMethods}>
      <form
        onSubmit={(e) => {
          formMethods.handleSubmit(onSubmit)(e)
        }}
        className={classNames([
          'ds-u-display--flex',
          'ds-u-align-items--end',
          'my-u-gap-x--8',
          className
        ])}
      >
        <MyDropdown
          name="sortType"
          className=""
          label={t('sortByFieldLabel')}
          labelClassName="ds-c-label ds-u-margin-top--0 ds-u-margin-bottom--1"
          id="msp-sort-type"
          fieldClassName="ds-u-margin--0"
          options={sortByOpts}
        />
        <MyDropdown
          name="sortDirection"
          className=""
          label="&nbsp;"
          ariaLabel={t('sortDirectionFieldLabel')}
          labelClassName="ds-c-label ds-u-margin-top--0 ds-u-margin-bottom--1"
          id="msp-sort-order"
          fieldClassName="ds-u-margin--0"
          options={sortDirectionOpts}
        />
        <Button
          className={classNames([
            'ds-c-button',
            'ds-c-button--solid',
            'ds-c-button--alternate',
            'ds-u-padding-x--4',
            'ds-u-padding-y--2'
          ])}
          type="submit"
          siteActivityProps={{
            core: {
              component: classType === 'msa' ? 'Medicare Set Aside' : 'Medicare Secondary Payer',
              elementId: classType === 'msa' ? 'msa_sortcases_click' : 'msp_sortcases_click',
              coreClickData: {
                // Pass custom link text to include the sort key without needing a separate event key
                linkText: `${formMethods.getValues().sortType};${formMethods.getValues().sortDirection}`
              }
            }
          }}
        >
          {t('sortButtonLabel')}
        </Button>
      </form>
    </FormProvider>
  )
}
